import { NavLink, useLocation } from 'react-router-dom';

import { Permission } from '../../../../../../../backend/src/auth/permissions/permission';
import { TrackingEvents } from '../../../../../analytics/events';
import { trackCustomEvent } from '../../../../../analytics/Mixpanel';
import { User } from '@/api/types/backend-dto-types';
import { useHasPermission } from '@/hooks/useHasPermission';

interface NavigationTabsProps {
  caseId: string;
  user: User | undefined;
}

const NavigationTabs = ({ caseId, user }: NavigationTabsProps) => {
  const location = useLocation();
  const { hasPermission } = useHasPermission();

  // Get the current view from the 4th segment in the path
  const pathSegments = location.pathname.split('/');
  const currentView = pathSegments[4];

  // Determine the active tab based on the 4th segment
  const getActiveItem = () => {
    if (currentView === 'data') return 'data';
    if (currentView === 'summary') return 'summary';
    if (currentView === 'assistant') return 'assistant';
    if (currentView === 'transcripts') return 'transcripts';
    if (currentView === 'settings') return 'settings';
    return '';
  };

  const activeItem = getActiveItem();

  return (
    <div className="h-8 border-b border-gray-200">
      <nav className="flex space-x-8">
        <NavLink
          to={`/app/chronos/case-editor/summary?caseId=${caseId}`}
          className={`text-sm font-medium transition-colors ${
            activeItem === 'summary'
              ? 'border-brandSecondary text-brandSecondary border-b-2'
              : 'text-gray-700 hover:border-b-2 hover:border-gray-300 hover:text-gray-700'
          }`}
        >
          Summary
        </NavLink>
        <NavLink
          to={`/app/chronos/case-editor/data/facts?caseId=${caseId}`}
          className={`text-sm font-medium transition-colors ${
            activeItem === 'data'
              ? 'border-brandSecondary text-brandSecondary border-b-2'
              : 'text-gray-700 hover:border-b-2 hover:border-gray-300 hover:text-gray-700'
          }`}
        >
          Data
        </NavLink>
        <NavLink
          to={`/app/chronos/case-editor/assistant?caseId=${caseId}`}
          className={`text-sm font-medium transition-colors ${
            activeItem === 'assistant'
              ? 'border-brandSecondary text-brandSecondary border-b-2'
              : 'text-gray-700 hover:border-b-2 hover:border-gray-300 hover:text-gray-700'
          }`}
        >
          Kim
        </NavLink>

        {hasPermission(Permission.RealtimeUse) && (
          <NavLink
            to={`/app/chronos/case-editor/transcripts?caseId=${caseId}`}
            className={`text-sm font-medium transition-colors ${
              activeItem === 'transcripts'
                ? 'border-brandSecondary text-brandSecondary border-b-2'
                : 'text-gray-700 hover:border-b-2 hover:border-gray-300 hover:text-gray-700'
            }`}
          >
            Realtime
          </NavLink>
        )}

        <NavLink
          to={`/app/chronos/case-editor/settings/metadata?caseId=${caseId}`}
          className={`relative text-sm font-medium transition-colors ${
            activeItem === 'settings'
              ? 'border-brandSecondary text-brandSecondary border-b-2'
              : 'text-gray-700 hover:border-b-2 hover:border-gray-300 hover:text-gray-700'
          }`}
          onClick={() => {
            trackCustomEvent(TrackingEvents.OpenCaseSettings);
          }}
        >
          Settings
        </NavLink>
      </nav>
    </div>
  );
};

export default NavigationTabs;
